export default "__VITE_ASSET__DMS0IUUf__"